import type { CSSProperties } from "react";

export function SkeletonLine({ width = "100%", height = 12 }: { width?: string | number; height?: number }) {
  const style: CSSProperties = { width, height, display: "block", borderRadius: 4 };
  return <span className="klu-skeleton" style={style} />;
}

export function SkeletonBox({ width = "100%", height = 80 }: { width?: string | number; height?: number }) {
  const style: CSSProperties = { width, height, display: "block", borderRadius: 10 };
  return <div className="klu-skeleton" style={style} />;
}

export function SkeletonCircle({ size = 32 }: { size?: number }) {
  const style: CSSProperties = { width: size, height: size, display: "inline-block", borderRadius: "50%" };
  return <span className="klu-skeleton" style={style} />;
}
